import { useDispatch, useSelector } from 'react-redux';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'antd/es/button';
import Loader from '../../../../components/Loader';
import { CLEAR_MESSAGES_STORE, MESSAGES_INFO, REPLY_MESSAGE } from '../../../../redux/actions/messagesActions';
import { HIDE_NEW_MESSAGES } from '../../../../redux/actions/componentsActions';
import { CHAT_INFO } from '../../../../redux/actions/currentChatActions';
import IndividualChatItem from './IndividualChatItem';
import { sessionStorageWrapper } from '../../../../helpers/storageFactory';
import { getCommonRoutePath, getUniversityId, isUniGroup } from '../../../../helpers/Helpers';

const ChatsSidebar = ({ goToMessages, handleShowMoreButtonClick }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { institution, isMobile } = useSelector((state) => state.widget);
    const currentChat = useSelector((state) => state.currentChat);
    const dialogs = useSelector((state) => state.dialogs);

    const handleChatClick = useCallback(
        (id) => {
            const institutionSlug = institution ? institution.slug : null;
            sessionStorageWrapper.setItem(
                'activePage',
                JSON.stringify({
                    id,
                    universityId: getUniversityId(),
                    isGroup: isUniGroup(),
                    page: 'chat',
                    institutionSlug,
                })
            );

            dispatch({
                type: CHAT_INFO,
                payload: {
                    dialog_id: id,
                    firstLoad: false,
                    type: 1,
                },
            });

            dispatch({
                type: REPLY_MESSAGE,
                payload: {
                    activeMessage: null,
                    activePublisher: null,
                },
            });
            dispatch({
                type: CLEAR_MESSAGES_STORE,
            });

            dispatch({
                type: MESSAGES_INFO,
                payload: {
                    dialog_id: id,
                    dialog_type: 1,
                    blockReloadChat: true,
                    resetMessagesCounter: true,
                },
            });

            dispatch({
                type: HIDE_NEW_MESSAGES,
            });

            if (isMobile) {
                goToMessages();
            }
            navigate(`${getCommonRoutePath()}/interaction/dialogs/` + id);
        },
        [dispatch, navigate, institution, isMobile]
    );

    if (dialogs.isLoading) {
        return (
            <div className="chat-nav">
                <Loader />
            </div>
        );
    }

    let chatsView = '';
    let chatsIncludesCurrentChat = false;
    if (dialogs.items && dialogs.items.length) {
        chatsView = dialogs.items.map((chat, index) => {
            if (currentChat.firstChat.id === chat.id) {
                chatsIncludesCurrentChat = true;
            }
            return (
                <IndividualChatItem
                    key={chat.id + '' + chat.new_messages}
                    index={+index}
                    chat={chat}
                    handleChatClick={handleChatClick}
                    isCurrentChat={currentChat.data.id === chat.id}
                />
            );
        });
    }

    const showMoreButton = (
        <Button
            className="show-more-dialogs-button"
            type="link"
            onClick={() => handleShowMoreButtonClick(dialogs.lastOffset)}
        >
            Show more conversations
        </Button>
    );
    return (
        <div className="chat-nav individual-chats">
            <div
                className={
                    dialogs.isLoading || !dialogs || !dialogs.items || (dialogs.items && !dialogs.items.length)
                        ? ''
                        : 'chat-nav-list'
                }
            >
                {!chatsIncludesCurrentChat && currentChat.firstChat.id && currentChat.firstChat.type === 1 && (
                    <IndividualChatItem
                        key={currentChat.firstChat.id + '' + currentChat.firstChat.new_messages}
                        chat={currentChat.firstChat}
                        handleChatClick={handleChatClick}
                        isCurrentChat={currentChat.firstChat.id === currentChat.data.id || !currentChat.data.id}
                    />
                )}
                {chatsView}
                {!currentChat.data.id && (!dialogs.items || !dialogs.items.length) && (
                    <div className="no-dialog-found">No search results</div>
                )}
                {dialogs.lastReceivedCount === 100 && showMoreButton}
            </div>
        </div>
    );
};

export default ChatsSidebar;
